import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TStepListProps = {
  children: ReactNode;
  className?: string;
};

export function StepList({ children, className }: TStepListProps) {
  return (
    <div className={cn("flex w-full flex-col items-start justify-center gap-[8px] py-[4px]", className)}>
      {children}
    </div>
  );
}
